import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { useAuth } from "../../../components/context/AuthContext";

import {
  getFreightRequestDetail,
  syncFreightGoogleResponses,
} from "../../../api/director/navlunApi";

import { formatDate, formatPrice, copyText } from "./navlunHelpers";

function DirectorNavlunRequestDetailPage() {
  const { user } = useAuth();

  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(null);

  const getIdFromUrl = () => {
    const parts = window.location.pathname.split("/");
    return parts[parts.length - 1];
  };

  const requestId = getIdFromUrl();

  const fetchDetail = useCallback(async () => {
    try {
      setLoading(true);

      const response = await getFreightRequestDetail(requestId);

      if (response?.data?.success) {
        setDetail(response.data.data);
      } else {
        alert(response?.data?.message || "Detay alınamadı.");
      }
    } catch (error) {
      console.error("Navlun detay alma hatası:", error);
      alert(
        error?.response?.data?.message || "Teklif talebi detayı alınamadı."
      );
    } finally {
      setLoading(false);
    }
  }, [requestId]);

  useEffect(() => {
    fetchDetail();
  }, [fetchDetail]);

  const handleSyncResponses = async () => {
    try {
      setLoading(true);

      const response = await syncFreightGoogleResponses(requestId);

      if (response?.data?.success) {
        const data = response.data.data;

        alert(
          `Senkronizasyon tamamlandı.\nToplam: ${data.totalResponses}\nYeni: ${data.insertedCount}\nGüncellenen: ${data.updatedCount}\nEşleşmeyen: ${data.unmatchedCount}`
        );

        await fetchDetail();
      } else {
        alert(response?.data?.message || "Cevaplar senkronize edilemedi.");
      }
    } catch (error) {
      console.error("Google cevap sync hatası:", error);
      alert(
        error?.response?.data?.message ||
          "Cevaplar senkronize edilirken hata oluştu."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCopyLink = async (url) => {
    const copied = await copyText(url);

    alert(copied ? "Link kopyalandı." : "Link kopyalanamadı.");
  };

  if (!user) return null;

  const request = detail?.request;
  const offers = detail?.offers || [];

  return (
    <Layout>
      <div className="content-body" style={{ width: "100%", padding: "20px" }}>
        <section className="app-user-list">
          <div className="row">
            <div className="col-12">
              <div
                className="card"
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                }}
              >
                <div className="card-header border-bottom p-4 d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="card-title m-0">
                      Navlun Teklif Talebi Detayı
                    </h4>
                    <small className="text-muted">
                      Talep bilgileri ve gelen firma teklifleri.
                    </small>
                  </div>

                  <div>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm me-2"
                      onClick={() => window.history.back()}
                    >
                      Geri
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={fetchDetail}
                      disabled={loading}
                    >
                      Yenile
                    </button>
                  </div>
                </div>

                <div className="card-body pt-3">
                  {loading && (
                    <div className="alert alert-info py-2">
                      İşlem yapılıyor...
                    </div>
                  )}

                  {!request ? (
                    <div className="alert alert-secondary">
                      Detay yükleniyor...
                    </div>
                  ) : (
                    <>
                      <div className="card border mb-3">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start">
                            <div>
                              <h5 className="mb-2">
                                {request.requestCode} - {request.title}
                              </h5>

                              <p className="mb-1">
                                <strong>Rota:</strong> {request.routeFrom} →{" "}
                                {request.routeTo}
                              </p>

                              <p className="mb-1">
                                <strong>Yıl:</strong> {request.year}
                              </p>

                              <p className="mb-1">
                                <strong>Yük Tipi:</strong>{" "}
                                {request.loadType || "-"}
                              </p>

                              <p className="mb-1">
                                <strong>Miktar:</strong>{" "}
                                {request.quantity || "-"}{" "}
                                {request.quantityUnit || ""}
                              </p>

                              <p className="mb-1">
                                <strong>Araç Tipi:</strong>{" "}
                                {request.vehicleType || "-"}
                              </p>

                              <p className="mb-1">
                                <strong>Para Birimi:</strong> {request.currency}
                              </p>

                              <p className="mb-1">
                                <strong>Son Tarih:</strong>{" "}
                                {formatDate(request.dueDate)}
                              </p>

                              <p className="mb-1">
                                <strong>Durum:</strong> {request.status}
                              </p>

                              <p className="mb-0">
                                <strong>Açıklama:</strong>{" "}
                                {request.description || "-"}
                              </p>
                            </div>

                            <div className="text-end">
                              {request.googleResponderUrl ? (
                                <>
                                  <a
                                    href={request.googleResponderUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-sm btn-outline-success mb-2"
                                  >
                                    Formu Aç
                                  </a>

                                  <br />

                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary mb-2"
                                    onClick={() =>
                                      handleCopyLink(request.googleResponderUrl)
                                    }
                                  >
                                    Link Kopyala
                                  </button>

                                  <br />

                                  <button
                                    type="button"
                                    className="btn btn-sm btn-success"
                                    onClick={handleSyncResponses}
                                  >
                                    Cevapları Çek
                                  </button>
                                </>
                              ) : (
                                <span className="badge bg-warning">
                                  Google Form oluşturulmamış
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card border mb-3">
                        <div className="card-header">
                          <h5 className="m-0">Seçilen Firmalar</h5>
                        </div>

                        <div className="card-body">
                          {request.selectedCompanies &&
                          request.selectedCompanies.length > 0 ? (
                            <div className="table-responsive">
                              <table className="table table-bordered table-hover">
                                <thead className="table-light">
                                  <tr>
                                    <th>Firma</th>
                                    <th>Yetkili</th>
                                    <th>E-posta</th>
                                    <th>Telefon</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {request.selectedCompanies.map((company) => (
                                    <tr key={company._id}>
                                      <td>{company.companyName}</td>
                                      <td>{company.contactName || "-"}</td>
                                      <td>{company.email || "-"}</td>
                                      <td>{company.phone || "-"}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="alert alert-secondary mb-0">
                              Seçili firma bulunamadı.
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="table-responsive">
                        <table className="table table-hover table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th>Firma</th>
                              <th>E-posta</th>
                              <th>Navlun</th>
                              <th>Line</th>
                              <th>Freetime</th>
                              <th>Teslim TT</th>
                              <th>Toplam</th>
                              <th>Teslim</th>
                              <th>Geçerlilik</th>
                              <th>Durum</th>
                            </tr>
                          </thead>

                          <tbody>
                            {offers.length > 0 ? (
                              offers.map((offer) => (
                                <tr key={offer._id}>
                                  <td className="fw-bold">
                                    {offer.companyId?.companyName ||
                                      offer.companyName ||
                                      "-"}
                                  </td>

                                  <td>{offer.email || "-"}</td>

                                  <td>
                                    {formatPrice(
                                      offer.freightPrice,
                                      offer.currency
                                    )}
                                  </td>

                                  <td>{offer.line || "-"}</td>

                                  <td>{offer.freeTime || "-"}</td>

                                  <td>{offer.deliveryTransitTime || "-"}</td>

                                  <td className="fw-bold">
                                    {formatPrice(
                                      offer.totalPrice,
                                      offer.currency
                                    )}
                                  </td>

                                  <td>
                                    {offer.deliveryDay
                                      ? `${offer.deliveryDay} gün`
                                      : "-"}
                                  </td>

                                  <td>{formatDate(offer.validityDate)}</td>

                                  <td>
                                    <span
                                      className={`badge ${
                                        offer.status === "submitted"
                                          ? "bg-success"
                                          : "bg-warning"
                                      }`}
                                    >
                                      {offer.status}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center p-4">
                                  Teklif cevabı bulunamadı.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default DirectorNavlunRequestDetailPage;
